import { type RoomDto } from "@crowdcoursing/api/openapi";
import { createSlice, isAnyOf, type PayloadAction } from "@reduxjs/toolkit";

import { type NullSanitized } from "~utils/sanitizeDto";

import {
  deleteEvent,
  deleteRsvp,
  leave,
  requestMembership as requestMembershipSession,
  rsvp,
  updateMeetingTime,
} from "../actions/events";
import {
  createPod,
  deletePod,
  getMyPods,
  removeMember as removePodMember,
  requestMembership as requestMembershipPod,
  updatePod,
} from "../actions/pods";
import { type PodState } from "./state";

/** @deprecated We are phasing out `redux` */
const initialState: PodState = {
  isLoading: false,
  myPods: [],
};

/** @deprecated We are phasing out `redux` */
export const pods = createSlice({
  extraReducers: (builder) =>
    builder
      // @ts-expect-error Complains about `Date | undefined` not being assignable to `string | undefined`
      .addCase(getMyPods.fulfilled, (state: PodState, action: PayloadAction<NullSanitized<RoomDto>[]>) => {
        state.myPods = action.payload;
      })
      .addMatcher(
        isAnyOf(
          createPod.pending,
          updatePod.pending,
          deletePod.pending,
          deleteEvent.pending,
          updateMeetingTime.pending,
        ),
        (state: PodState) => {
          state.isLoading = true;
        },
      )
      .addMatcher(
        isAnyOf(
          createPod.rejected,
          createPod.fulfilled,
          updatePod.rejected,
          updatePod.fulfilled,
          deletePod.rejected,
          deletePod.fulfilled,
          deleteEvent.rejected,
          deleteEvent.fulfilled,
          updateMeetingTime.rejected,
          updateMeetingTime.fulfilled,
          removePodMember.fulfilled,
        ),
        (state: PodState) => {
          state.isLoading = false;
        },
      )
      .addMatcher(
        isAnyOf(
          removePodMember.fulfilled,
          leave.fulfilled,
          requestMembershipPod.fulfilled,
          requestMembershipSession.fulfilled,
          rsvp.fulfilled,
          deleteRsvp.fulfilled,
          updateMeetingTime.fulfilled,
        ),
        // @ts-expect-error todo: figure out the correct type
        (state: PodState, action: PayloadAction<RoomDto>) => {
          const index = state.myPods.findIndex(
            (result) => result?.id === action?.payload?.id && result.id && action.payload && action.payload.id,
          );
          if (index !== -1) {
            // @ts-expect-error Complains about `Date | undefined` not being assignable to `string | undefined`
            state.myPods[index] = action.payload;
          }
        },
      ),
  initialState,
  name: "pods",
  reducers: {},
});
